import { MutedTarget } from '@energybox/react-ui-library/dist/types';

export type MutedTargetsByTargetId = {
  [targetId: string]: MutedTarget;
};

const isSameMuteWindow = (initial: MutedTarget, updated: MutedTarget) =>
  initial.targetMutedFrom === updated.targetMutedFrom &&
  initial.targetMutedUntil === updated.targetMutedUntil &&
  initial.targetMutedReason === updated.targetMutedReason;

export const diffMutedTargets = (
  initialByTargetId?: MutedTargetsByTargetId,
  updatedByTargetId?: MutedTargetsByTargetId
) => {
  const initialById = initialByTargetId || {};
  const updatedById = updatedByTargetId || {};

  const unmuteTargetIds = Object.values(initialById)
    .filter(target => !updatedById[target.targetId])
    .map(target => target.targetId);

  const targetsToMute = Object.values(updatedById).filter(target => {
    const initial = initialById[target.targetId];
    if (!initial) return true;
    return !isSameMuteWindow(initial, target);
  });

  return { unmuteTargetIds, targetsToMute };
};
